/* ============================================================
   Watch Reserves — light/dark mode toggle.

   In the Framer build this was ~250 lines of [style*="#0E0C0A"]
   attribute-selector sweeps injected as a <style> tag, because every
   colour was an inline style with nothing to override. Here it flips
   one class and the custom properties in wr-tokens.css do the rest.

   The pre-paint half of this lives inline in layout/theme.liquid so
   there is no flash of the dark palette for a light-mode visitor.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'wr_light_mode';
  var MOBILE = 768;

  function isMobile() {
    return window.innerWidth <= MOBILE;
  }

  function apply(light) {
    document.documentElement.classList.toggle('wr-light', light);
  }

  document.querySelectorAll('[data-wr-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var light = !document.documentElement.classList.contains('wr-light');
      apply(light);
      try {
        localStorage.setItem(KEY, String(light));
      } catch (e) { /* private browsing */ }
    });
  });

  // Mobile has no toggle, so a stored light preference set on desktop would
  // strand a phone visitor in light mode with no control to undo it. Pin dark
  // below the breakpoint, and re-check on resize/orientation change.
  function reconcile() {
    if (isMobile()) {
      apply(false);
      return;
    }
    var stored = null;
    try {
      stored = localStorage.getItem(KEY);
    } catch (e) { /* ignore */ }
    apply(stored === 'true');
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(reconcile, 150);
  });
})();
